//export const API_BASE_URL="http://localhost:3000";
export const API_BASE_URL="https://api.zwato.com";
export const MEDIA_BASE_URL="https://media.zwato.com";
//export const BASE_URL="http://localhost:3001";
export const BASE_URL="https://app.zwato.com";

 